var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFontSize = function SvgFontSize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 44 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 20.6H2.7l-1 3.4H0l4.3-13h1.4L10 24H8.3zm-4-1.4h3.6L5 13.3z",
    className: "font-size_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.1 19h-6.3l-1.4 5H11l6-19h2l6 19h-2.4zm-5.6-2h5.1L18 8.3zM39 17.7h-8.1L29.1 24H26l7.7-24h2.6L44 24h-3.1zm-7.3-2.6h6.5L35 4.2z"
  })));
};
export default SvgFontSize;